import { useQuery } from '@tanstack/react-query';
import { apiClient, getErrorStatus } from '@tark/shared/lib';

type Quota = { includedEvents: number; adminGrantedEvents: number; usedEvents: number; remainingEvents: number };
export function OrganizerQuotaCard({ tenantId }: { tenantId: number }) {
  const quota = useQuery({
    queryKey: ['organizer-event-quota', tenantId],
    retry: (failures, error) => !((getErrorStatus(error) ?? 0) >= 400 && (getErrorStatus(error) ?? 0) < 500) && failures < 2,
    queryFn: async () => {
      const response = await apiClient.get<Quota>('/api/v1/web/organizer/event-quota');
      if (!Number.isFinite(response.data.remainingEvents)) throw new Error('Invalid quota response');
      return response.data;
    },
  });
  if (getErrorStatus(quota.error) === 403) return null;
  return <section aria-label="Free event allowance" className="rounded-xl border border-border bg-surface p-4 text-sm text-text">
    <p className="font-semibold">Free event allowance</p>
    {quota.data ? <>
      <p>{quota.data.remainingEvents} free {quota.data.remainingEvents === 1 ? 'event' : 'events'} remaining · {quota.data.usedEvents} used</p>
      {quota.data.remainingEvents === 0 && <p>Contact TARK for additional events.</p>}
    </> : <p role={quota.isError ? 'alert' : 'status'}>{quota.isError ? "Couldn't load your allowance." : 'Loading allowance…'}</p>}
    <p className="mt-1 text-text-muted">{quota.data ? `${quota.data.includedEvents + quota.data.adminGrantedEvents} free ${quota.data.includedEvents + quota.data.adminGrantedEvents === 1 ? 'event' : 'events'} in total.` : 'Your approved free event allowance.'} An event counts when first published. Cancelling before any registration returns it.</p>
  </section>;
}
